<div class="risk-info-container">
  <div class="risk-info">
    {{ 'newPortfolio.filters.conservative' | translate }}
  </div>
  <div class="risk-info">
    {{ 'newPortfolio.filters.dynamic' | translate }}
  </div>
</div>

<div class="full-slider-container" [ngClass]="{'full-slider-container--one-risk-workaround': options.maxValue === 1}">

  <div class="slidecontainer">
    <input
      class="slider"
      [ngClass]="{'one-risk-score-workaround': options.maxValue === 1}"
      type="range"
      min="{{ options.minValue }}"
      max="{{ options.maxValue }}"
      step="{{ options.step }}"
      [(ngModel)]="currentValue"
      (input)="sliderInputUpdated($event)"
      [disabled]="disabled"
      >
    </div>

    <div class="bar-extension">
      @for (riskLevel of [].constructor(defaultRiskLevels.length - options.maxValue); track $index) {
        <div class="extended-line"></div>
      }
    </div>
  </div>
  <div class="risk-bar mt-1">
    @for (riskLevel of defaultRiskLevels; track riskLevel; let index = $index) {
      <div
        class="legend"
    [ngClass]="{
      'legend--active': index + 1 === currentValue,
      'legend--before': index + 1 < currentValue,
      'legend--suggested': index + 1 === options.maxValue,
      'legend--disabled': index + 1 > options.maxValue || disabled
    }"
        (click)="(index + 1 > options.maxValue || disabled) ? true : updateValue(index + 1)"
        (keydown.space)="(index + 1 > options.maxValue || disabled) ? true : updateValue(index + 1)"
        (keydown.enter)="(index + 1 > options.maxValue || disabled) ? true : updateValue(index + 1)"
        tabindex="0"
        [attr.data-cy]="'risk-score-switch-btn-' + (index + 1)"
        >
        @if (index + 1 !== options.maxValue) {
          {{ index + 1 }}
        } @else {
          {{ index + 1 }}
          <div class="suggested-highlight">
            <div class="highlight-text">
              {{ 'newPortfolio.filters.suggestedRiskProfile' | translate }}
            </div>
            <libero-tooltip-button [whiteStyling]="true" [explainPerson]="'jiri_mikes'">
              {{ 'global.tooltips.suggestedForYou' | translate }}
            </libero-tooltip-button>
          </div>
        }
      </div>
    }
  </div>